import { createFileRoute } from '@tanstack/react-router';
import { FilesPage } from '@/features/file/list-page';
import { requirePermission } from '@/features/auth/access';
export const Route = createFileRoute('/_authenticated/system/files')({
  beforeLoad: ({ context, location }) =>
    requirePermission(context.queryClient, location.href, 'files:read'),
  component: FilesPage,
});
